<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" fixed clipped app style="border: none !important;background-color:#f99420">
      <!-- <h2 @click="drawer = !drawer" style="cursor:pointer;padding:10px" class="white--text hdr1">Worldwin</h2> -->
      <div style="background-color:white">
        <img src="../assets/worldwin-logo-1.png" height="70px" class="center" />
      </div>
      
      <v-divider color="grey" style="margin-top:0px"></v-divider>
      <div class="" style=" text-align: center; padding: 20px;">
                                 
                          <v-avatar v-if="profilePic!=null&&showPic==true" style="margin-bottom:15px;height: 80px;width: 80px;">
                          <v-img
                            :src="profilePic"
                            alt="John"
                          ></v-img>
                        </v-avatar>
                        <v-avatar v-if="profilePic==null||showPic==false" style="margin-bottom:15px;height: 80px;width: 80px;">
                          <v-img
                            src="https://w7.pngwing.com/pngs/708/467/png-transparent-avatar-default-head-person-unknown-user-anonym-user-pictures-icon.png"
                            alt="John"
                          ></v-img>
                        </v-avatar>
                        <h4 style="color:#ffffff;margin-bottom: 0px;">{{ loggedInUserName }}<span style="font-size:16px"></span></h4>

                    </div>

      <template v-if="roleType=='Student'">
        <v-list dense >
        <template>
          <v-list-tile
           @click="onDashboard()">
            <v-list-tile-action class="icon-list">
              <v-icon  color="#000">dashboard</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="activeMenu menulist">Dashboard</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile
          @click="onProfile()"
          class="black--text activeMenu">
            <v-list-tile-action class="icon-list">
              <v-icon color="#000" class="activeMenu">person</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="activeMenu menulist">My Profile</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <!-- <v-list-tile
          @click="onRegistration()"
           class="black--text">
            <v-list-tile-action class="icon-list">
              <v-icon color="#000">how_to_reg</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="menulist">Registration</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile> -->
          <!-- <v-divider></v-divider> -->
          <v-list-tile
          @click="onTrainingProcess()"
           class="black--text">
            <v-list-tile-action class="icon-list">
              <v-icon color="#000">school</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="activeMenu menulist">Training Process</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile
          v-if="applicationShow==true"
          @click="onApplicationProcess()"
           class="black--text">
            <v-list-tile-action class="icon-list">
              <v-icon color="#000">description</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="activeMenu menulist">Application Process</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <!-- <v-list-tile
          @click="onVisaProcess()"
           class="black--text">
            <v-list-tile-action class="icon-list">
              <v-icon color="#000">public</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="menulist">Visa Process</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile> -->
          <!-- <v-divider></v-divider>
          <v-list-tile
          @click="onUniversityRegistration()"
           class="black--text">
            <v-list-tile-action class="icon-list">
              <v-icon color="#000">account_balance</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="menulist">University Reg</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile> -->
        </template>
      </v-list>
</template>





<template v-if="roleType=='Sub Agent'">
        <v-list dense >
        <template>
          <v-list-tile
           @click="onDashboard1()">
            <v-list-tile-action class="icon-list">
              <v-icon  color="#000">dashboard</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="activeMenu menulist">Dashboard</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
        </template>
      </v-list>
</template>

    </v-navigation-drawer>


    
    

    <!-- <v-toolbar flat class="bckcolor" app fixed clipped-left height="70px" style="padding-top:10px">
      <h2 @click="drawer = !drawer" style="cursor:pointer">SALONYX</h2>
      <v-spacer></v-spacer>
      <v-card flat width="1250px" style="border-radius:10px;padding-top:7px;padding-bottom:7px">
        <v-card-title style="padding:0px">
          <v-spacer></v-spacer>
          <v-badge
        color="red"
        right
        overlap
        size="0.2px"
        v-if="notification.count > 0"
      >
        <span slot="badge">{{notification.count}}</span>
        <v-btn icon class="ma-0">
          <v-icon @click="notify()"
          >
            notification_important
          </v-icon>
         </v-btn>
      </v-badge>
      <v-btn flat  @click="logOutDialog = true"><v-icon small>lock</v-icon>&nbsp;Logout</v-btn>
      <v-dialog v-model="logOutDialog" max-width="290" persistent>
                <v-card style="padding: 20px !important ; border-radius: 0px;border:1px solid;">
                  <v-sheet color="transparent" style="text-align:center">
                    <v-icon color="#0d47a1" :size="40">https</v-icon>
                  </v-sheet>
                  
                  <h3 style="text-align:center;font-size:20px;color:red">Logout</h3>

                  <v-card-text style="text-align:center;color:black">Are you sure you want to logout from Salonyx ?</v-card-text>

                  
                    <v-btn style="padding-left:60px" dark color="green" flat @click="logOutDialog = false">No</v-btn>
                    <v-btn dark color="red" flat @click="logOut()">Yes</v-btn>
                </v-card>
              </v-dialog>
        </v-card-title>
      </v-card>
      
    </v-toolbar> -->
    <v-content>
      <transition :name="transitionName" mode="out-in" @beforeLeave="beforeLeave" @enter="enter">
        <router-view>
          <!-- <h1>Hellow world</h1> -->
        </router-view>
      </transition>
    </v-content>
  </v-app>
</template>

<script>
const DEFAULT_TRANSITION = "fade";
import config from "../config1.json";
export default {
  data() {
   return{
    menu: false,
    drawer: null,
    fav: true,
    prevHeight: 0,

    transitionName: DEFAULT_TRANSITION,
    //menus: null,
    logOutDialog: false,
    roleType: sessionStorage.roles,
    loggedInUserName: sessionStorage.loggedInUserName,
    loggedInUserID: localStorage.loggedInUserID,
    theme: localStorage.theme,

    applicationShow: false,

    notification: [],

    profilePic: null,
    showPic: false,

    dashboard: true,
    settings: false,
    master: false,
    level2: false,

    "menus": [
        {
            "menuName": "Dashboard",
            "menuIcon": "dashboard",
            "menuLink": "/_",
            "parentMenu": ""
        },
        {
            "menuName": "Company",
            "menuIcon": "account_balance",
            "menuLink": "/company"
        },
        {
            "menuName": "Settings",
            "menuIcon": "settings",
            "menuLink": "/settings"
        },
        {
            "menuName": "Users",
            "menuIcon": "account_box",
            "menuLink": "/users"
        },
        {
            "menuName": "Salons",
            "menuIcon": "airline_seat_recline_extra",
            "menuLink": "/salons"
        },
        {
            "menuName": "Customers",
            "menuIcon": "people",
            "menuLink": "/customers"
        },
        {
            "menuName": "Booking",
            "menuIcon": "book",
            "menuLink": "/bookings"
        },
        {
            "menuName": "Online Enquiry",
            "menuIcon": "contact_support",
            "menuLink": "/onlineEnquiry"
        },
        {
            "menuName": "Reports",
            "menuIcon": "verified_user",
            "menuLink": "/reports"
        }
    ],
  }
  },
  props: {
    source: String
  },

  methods: {

    getData() {
      let id = sessionStorage.getItem("loggedInUserID");

      let userType = sessionStorage.getItem("roles");

      if(userType=="Student") {
        this.axios
      .get(config.API + 'Admin/' + id, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let studentId = res.data.studentId;

        this.axios
        .get(config.API + "Leads/" + studentId, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.applicationShow = res.data.applicationShow;
          this.profilePic = res.data.profileSrc;
          this.showPic = res.data.showPic;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.$Progress.fail();
        });
      });
      }
      
    },
    
    doRefresh() {
      window.location.reload();
    },
    goDash() {
      this.$router.push(`/_`);
    },
    onDashboard() {
      this.$router.push("/dashboard");
    },
    onDashboard1() {
      this.$router.push("/subagent-dashboard");
    },
    onProfile() {
      this.$router.push("/studentProfile");
    },
    onRegistration() {
      this.$router.push("/studentRegistration");
    },
    onTrainingProcess() {
      this.$router.push("/studentTrainingProcess");
    },
    onApplicationProcess() {
      this.$router.push("/studentApplicationProcess");
    },
    onVisaProcess() {
      this.$router.push("/studentVisaProcess");
    },
    onUniversityRegistration() {
      this.$router.push("/studentUniversityRegistration");
    },
    dshbtn() {
      this.settings = false;
      this.master = false;
      this.level2 = false;
      this.dashboard = true;
    },

    sttngbtn() {
      this.dashboard = false;
      this.master = false;
      this.level2 = false;
      this.settings = true;
    },

    mstrbtn() {
      this.dashboard = false;
      this.settings = false;
      this.level2 = false;
      this.master = true;
    },

    lvl2Btn() {
      this.dashboard = false;
      this.settings = false;
      this.master = false;
      this.level2 = true;
    },

    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      this.prevHeight = getComputedStyle(element).height;
    },

    changePassword() {
      this.$router.push(`changePassword/${this.loggedInUserID}`);
    },
    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
    // getData() {
    //   this.axios
    //     .get(config.API + "NotificationDocuments", {
    //       headers: {
    //         Authorization: "bearer " + localStorage.getItem("token")
    //       }
    //     })
    //     .then(res => {
    //       this.notification = res.data;

    //       this.$Progress.finish();
    //       this.getData();
    //     })
    //     .catch(() => {
    //       this.$Progress.fail();
    //     });
    // },
  },

  created() {
    /* this.menus = Object.values(
      JSON.parse(localStorage.getItem("menus") || "[]")
    ).map(function(menu) {
      return menu;
    }); */
    // this.getData();
    this.getData();
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;
      if (transitionName === "slide") {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
      }
      this.transitionName = transitionName || DEFAULT_TRANSITION;
      next();
    });

    
    
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Prompt&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Fugaz+One&display=swap');
.menulist {
  font-family: 'Prompt', sans-serif !important;
  font-size: 13px;
}
.hdr1 {
 font-family: 'Fugaz One', cursive;
 color: #e0e0e0;
}
.cmpny {
  font-family: 'Archivo Black', sans-serif;
}
hr {
  border: #fff;
}
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
.menu--text {
  color: #424242 !important;
}
.active--text {
  color: #0d47a1 !important;
}

.activeMenu:hover {
  color: white;
  cursor: pointer;
}

.bckcolor {
  background-color: #F1F1FD !important;
}
.xxx {
  background-color: white !important;
  margin: 10px !important;
  border-radius: 5px !important;
  font-weight: bold !important; 
  color: black !important;
}
.icon-list  {
     padding: 15px;
     color: #000;
}
</style>
